// Auth
export const LOGIN = 'auth/login';


// Notice Type
export const ADD_NOTICE_TYPE = 'noticetype/add';
export const GET_NOTICE_TYPE_LIST = 'noticetype/list';
export const EDIT_NOTICE_TYPE = 'noticetype/edit/';
export const EDIT_NOTICE_TYPE_STATUS = 'noticetype/changestatus/';
export const DELETE_NOTICE_TYPE = 'noticetype/delete/';

// Depots
export const ADD_DEPOTS = 'depot/add';
export const GET_DEPOTS_LIST = 'depot/list';
export const EDIT_DEPOTS = 'depot/edit/';
export const EDIT_DEPOTS_STATUS = 'depot/changestatus/';
export const DELETE_DEPOTS = 'depot/delete/';


// User
export const ADD_USER = 'user/add';
export const ADD_CSV_BULK_USERS = 'user/import';
export const GET_USER_LIST = 'user/list';
export const EDIT_USER = 'user/edit/';
export const EDIT_USER_STATUS = 'user/changestatus/';
export const DELETE_USER = 'user/delete/';


// driverManagement
export const GET_DRIVER_LIST = 'user/list';
export const CHANGE_DRIVER_DEPOTS = 'user/changedepot/';



// noticeManagement
export const GET_NOTICE_LIST = 'notice/list';
export const GET_NOTICE_TOTALS = 'notice/list/totals';
export const ADD_NOTICE = 'notice/add';
export const EDIT_NOTICE = 'notice/edit/'
export const DELETE_NOTICE = 'notice/delete/'
export const CHANGE_NOTICE_STATUS = 'notice/changestatus/'
export const NOTICE_VIEW_REPORT = 'notice/viewreport/'


